import React from "react";
import Typography from "@mui/material/Typography";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";
import { formatTitleCase, formatEmpty } from "../../../utils/formatHelpers";
import { nullCheck } from "../../../utils/dataHelpers";

const DefaultCell = (cell) => {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <StyledTooltip title={cell.value ? cell.value : ""}>
      <Typography variant="body1" color={active ? "white_opacity.100" : "black_solid.80"} className="Customized-table-overflow-cell">{formatEmpty(cell.value)}</Typography>
    </StyledTooltip>
  );
};

const TitleCaseCell = (cell) => {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <Typography variant="body1" color={active ? "white_opacity.100" : "black_solid.80"} className="Customized-table-overflow-cell">{formatEmpty(formatTitleCase(cell.value))}</Typography>
  );
};

const UpCaseCell = (cell) => {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <Typography variant="body1" color={active ? "white_opacity.100" : "black_solid.80"} className="Customized-table-overflow-cell">{formatEmpty(cell.value).toUpperCase()}</Typography>
  );
};

const ActiveBoldCell = (cell) => {
  const keyword = nullCheck(cell, null, "column", "keyword");
  const textArray = cell.value.split(keyword);
  return (
    <Typography variant="body2" color="primary.60" className="Customized-table-overflow-cell">
      {textArray.map((item, index) => (
        <span key={index}>
          {item}
          {index !== textArray.length - 1 && (
            <b>{keyword}</b>
          )}
        </span>
      ))}
    </Typography>
  );
};

export {
  DefaultCell,
  TitleCaseCell,
  UpCaseCell,
  ActiveBoldCell
};